import LaudoVisitaReport from "entity/LaudoVisita/reports/LaudoVisitaReport";
import { useState } from "react";
import ReportButton from "report/components/ReportButton";

export default function LaudoVisitaReportButton({ uid }) {
    const [report, setReport] = useState();

    // Cria Report apenas se clicado.
    function createReport() {
        let r = report;

        if (!report) {
            r = new LaudoVisitaReport(uid)
            setReport(r);
        }

        return r;
    }

    return <ReportButton report={createReport} />;
}
